import { useEffect, useRef, useState } from "react";

export const useCountdown = (initialTime: number) => {
	const [timeLeft, setTimeLeft] = useState(initialTime);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					if (intervalRef.current) clearInterval(intervalRef.current);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		};
	}, []);

	const reset = (resetTime: number = initialTime) => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
		}
		setTimeLeft(resetTime);
		intervalRef.current = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					if (intervalRef.current) clearInterval(intervalRef.current);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);
	};

	return { timeLeft, reset };
};
